import { get, filter, map } from 'lodash';

export function extractTitleParams(title = '', selector = '') {
  const ctl = title.split('__')[1] || '';
  const params = {
    name: title.split('__')[0],
    shouldHidden: ctl.includes('H'),
    shouldSum: ctl.includes('S'),
    shouldAverage: ctl.includes('A'),
    shouldCount: ctl.includes('C'),
    shouldFormatNumber: ctl.includes('N'),
  };
  if (!selector) return params;
  return params[selector];
}

export function parseJSON(dataString, defaultValue = []) {
  try {
    return JSON.parse(dataString);
  } catch (err) {
    return defaultValue;
  }
}

export const filterVisibleColumns = (key, _userConfig) => {
  const configColumns = get(_userConfig, `${key}.attr.value`, []);
  return filter(configColumns, (c2) => {
    return c2.visible;
  }).map((i) => i.id);
};

export const initLocalData = () => {
  localStorage.setItem('language', 'en');
};
